/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReviewPalAuthSubmissionRequest
 */
export interface ReviewPalAuthSubmissionRequest {
    /**
     * PAL auth integration ID (required if is_non_submission_flow is false)
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    pal_auth_integration_id?: string;
    /**
     * Whether this is a non-submission flow
     * @type {boolean}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    is_non_submission_flow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    include_lead_summary_report?: boolean;
}

/**
 * Check if a given object implements the ReviewPalAuthSubmissionRequest interface.
 */
export function instanceOfReviewPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewPalAuthSubmissionRequestFromJSON(json: any): ReviewPalAuthSubmissionRequest {
    return ReviewPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function ReviewPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pal_auth_integration_id': !exists(json, 'pal_auth_integration_id') ? undefined : json['pal_auth_integration_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
        'include_lead_summary_report': !exists(json, 'include_lead_summary_report') ? undefined : json['include_lead_summary_report'],
    };
}

export function ReviewPalAuthSubmissionRequestToJSON(value?: ReviewPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pal_auth_integration_id': value.pal_auth_integration_id,
        'is_non_submission_flow': value.is_non_submission_flow,
        'include_lead_summary_report': value.include_lead_summary_report,
    };
}

